import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-found',
    styleUrls: ['./not-found.component.scss'],
    templateUrl: './not-found.component.html',
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  public ngOnInit() {
  }

}
